import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Heart } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function ShowcaseGallery() {
  const {
    t
  } = useTranslation();
  const showcaseImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/inKRHT76haaLWjg3TQPaKQ/Edit14.png',
    label: t.showcase.labels.princessPurse
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jHTgX6d1XTcGoayVj4gxup/Edit4.jpg',
    label: t.showcase.labels.mirrorBagSet
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/vjndBR1AuZ9QbJaPm8XGr1/Edit34.png',
    label: t.showcase.labels.liloStitch
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mdipD758k1F2nubGKkgNkT/Edit8.jpg',
    label: t.showcase.labels.princessGiftSet
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/rhgGEC351p7rX7AvTyFGv1/Edit10.jpg',
    label: t.showcase.labels.characterBow
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/oi3XJ6gWXoR6VyxuWA161j/Edit22.png',
    label: t.showcase.labels.kpopBow
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/i6QDMhSGJtopmpX4yy92jo/Edit24.png',
    label: t.showcase.labels.rainbowBow
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2aAetUf4aKSfVnZUnfUz3N/Edit32.png',
    label: t.showcase.labels.animeTumbler
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jAHQsjVyB8V1Cvmt5Udk1Q/Edit5.jpg',
    label: t.showcase.labels.glitterPearlPurse
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/jDL7hMPVaDESJVXhBhY163/Edit41.png',
    label: t.showcase.labels.castlePrincess
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/fBDMTu4aZaTvo8spTeJkRp/Edit45.png',
    label: t.showcase.labels.signatureBox
  }];
  const marqueeItems = [...showcaseImages, ...showcaseImages];
  return <section className="py-24 bg-gradient-to-b from-white via-lavender-50/40 to-white relative overflow-hidden" data-id="element-410">
      <div className="absolute top-0 left-0 right-0 flex justify-center items-center pt-4" data-id="element-411">
        <div className="h-px w-full max-w-md bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-412"></div>
        <Heart className="w-4 h-4 text-blush-400 mx-4 fill-blush-200" data-id="element-413" />
        <div className="h-px w-full max-w-md bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-414"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-415">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-416">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-lavender-100 shadow-sm mb-6" data-id="element-417">
            <Sparkles className="w-4 h-4 text-lavender-500" data-id="element-418" />
            <span className="text-sm font-medium text-gray-600 uppercase tracking-wider" data-id="element-419">
              {t.showcase.badge}
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-4" data-id="element-420">
            {t.showcase.heading}
          </h2>
          <p className="font-script text-2xl text-lavender-600" data-id="element-421">
            {t.showcase.subheading}
          </p>
        </motion.div>
      </div>

      <div className="relative" data-id="element-422">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-white via-white/80 to-transparent z-10" data-id="element-423"></div>
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-white via-white/80 to-transparent z-10" data-id="element-424"></div>

        <motion.div className="flex gap-6 md:gap-8 py-6" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 35,
        repeat: Infinity,
        ease: 'linear'
      }} style={{
        width: 'max-content'
      }} data-id="element-425">
          {marqueeItems.map((item, index) => <motion.div key={index} whileHover={{
          y: -8,
          scale: 1.03
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} className="relative flex-shrink-0 w-64 md:w-80 group" data-id="element-426">
              <div className="relative aspect-[3/4] rounded-3xl overflow-hidden bg-white shadow-lg border-4 border-white" data-id="element-427">
                <div className="absolute inset-0 bg-gradient-to-t from-lavender-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" data-id="element-428"></div>
                <img src={item.src} alt={item.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-429" />

                <div className="absolute bottom-0 left-0 right-0 p-4 z-20 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500" data-id="element-430">
                  <div className="bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 inline-flex items-center gap-2 shadow-md" data-id="element-431">
                    <Sparkles className="w-3.5 h-3.5 text-lavender-500" data-id="element-432" />
                    <span className="text-sm font-medium text-gray-800" data-id="element-433">
                      {item.label}
                    </span>
                  </div>
                </div>

                <motion.div animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 15, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              delay: index * 0.2
            }} className="absolute top-3 right-3 z-20" data-id="element-434">
                  <div className="w-8 h-8 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-sm" data-id="element-435">
                    <Sparkles className="w-4 h-4 text-gold-500" data-id="element-436" />
                  </div>
                </motion.div>
              </div>
              <div className="absolute -inset-2 -z-10 bg-gradient-to-br from-lavender-200/0 via-blush-200/0 to-gold-200/0 group-hover:from-lavender-200/40 group-hover:via-blush-200/40 group-hover:to-gold-200/40 rounded-3xl blur-2xl transition-all duration-500" data-id="element-437"></div>
            </motion.div>)}
        </motion.div>
      </div>

      <div className="max-w-3xl mx-auto px-4 text-center mt-14" data-id="element-438">
        <p className="text-gray-600 text-lg italic" data-id="element-439">{t.showcase.footer}</p>
      </div>
    </section>;
}